export const useHttpCodes = () => {
    const codigosHttp = {
        100: "Continuar",
        101: "Cambiando protocolos",
        102: "Procesando",
        103: "Pistas tempranas",
        200: "OK",
        201: "Creado",
        202: "Aceptado",
        203: "Información no autorizada",
        204: "Sin contenido",
        205: "Restablecer contenido",
        206: "Contenido parcial",
        207: "Estado múltiple",
        208: "Ya reportado",
        226: "IM usado",
        300: "Múltiples opciones",
        301: "Movido permanentemente",
        302: "Encontrado",
        303: "Ver otro",
        304: "No modificado",
        305: "Usar proxy",
        307: "Redirección temporal",
        308: "Redirección permanente",
        400: "Solicitud incorrecta",
        401: "No autorizado",
        402: "Pago requerido",
        403: "Prohibido",
        404: "No encontrado",
        405: "Método no permitido",
        406: "No aceptable",
        407: "Autenticación de proxy requerida",
        408: "Tiempo de espera agotado",
        409: "Conflicto",
        410: "Ya no disponible",
        411: "Longitud requerida",
        412: "Precondición fallida",
        413: "Carga demasiado grande",
        414: "URI demasiado larga",
        415: "Tipo de medio no soportado",
        416: "Rango no satisfactorio",
        417: "Expectativa fallida",
        418: "Soy una tetera",
        421: "Solicitud mal dirigida",
        422: "Entidad no procesable",
        423: "Bloqueado",
        424: "Dependencia fallida",
        425: "Demasiado temprano",
        426: "Actualización requerida",
        428: "Precondición requerida",
        429: "Demasiadas solicitudes",
        431: "Campos de encabezado de solicitud demasiado grandes",
        451: "No disponible por razones legales",
        500: "Error interno del servidor",
        501: "No implementado",
        502: "Puerta de enlace incorrecta",
        503: "Servicio no disponible",
        504: "Tiempo de espera de la puerta de enlace agotado",
        505: "Versión HTTP no soportada",
        506: "La variante también negocia",
        507: "Almacenamiento insuficiente",
        508: "Bucle detectado",
        510: "No ampliado",
        511: "Autenticación de red requerida"
    };

    return {
        codigosHttp
    };
};
